import { getComplexUpcKey, isDefinedTrait } from '@nuxt-common/media-card-large/app/utils/getComplexUpcKey';

export type CheckIsSiblingUpcParams = {
  isConsolidatedThirdVariantFlag?: boolean;
  selectedColorId?: string | number | null;
  selectedSizeId?: string | number | null;
  selectedTypeId?: string | number | null;
  upcMap?: Record<string, string>;
  selectedUpcId?: string | number | null;
};

/**
 * Checks if the current selectedUpcId for a 3V product is a sibling fallback
 * when the exact combination of selected traits does not exist in the upcMap.
 */
export function checkIsSiblingUpc({
  isConsolidatedThirdVariantFlag,
  selectedColorId,
  selectedSizeId,
  selectedTypeId,
  upcMap = {},
  selectedUpcId,
}: CheckIsSiblingUpcParams): boolean {
  if (!isConsolidatedThirdVariantFlag || !selectedUpcId) {
    return false;
  }
  if (!selectedColorId || !selectedSizeId) {
    return false;
  }

  const complexKey = getComplexUpcKey(selectedColorId, selectedSizeId, selectedTypeId);
  const complexKey2 = isDefinedTrait(selectedTypeId) ? getComplexUpcKey(selectedColorId, selectedTypeId) : '';
  const hasExactUpc = Boolean(upcMap[complexKey] || (complexKey2 && upcMap[complexKey2]));

  return !hasExactUpc;
}

export default checkIsSiblingUpc;
